import api from "./api";
import type { NextBookConstraints, NextBookResponse } from "../types";

export const nextBookService = {
  async choose(payload: NextBookConstraints): Promise<NextBookResponse> {
    return (await api.post<NextBookResponse>("/next-book", payload)).data;
  },
};
